module.exports = __webpack_public_path__ + "static/media/021.de6e5ec7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/021.jpg
// module id = 318
// module chunks = 0